import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Button } from 'reactstrap';
import * as timeCardActions from '../../actions/timeCardActions';
import * as payWeekActions from '../../actions/payWeekActions';
import { loadUsers } from '../../actions/userActions';
import TimeCard from './TimeCard';
import AddTimeCardForUserModal from './AddTimeCardForUserModal';
import {
  payPeriodsToSelectOptions,
  usersToSelectOptions,
} from '../../utils/selectDataFormatters';
import { toast } from 'react-toastify';
import moment from 'moment/moment';

class TimeAdminPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  componentWillMount() {
    this.props.actions.loadPayPeriodWeeks().then(() => {
      this.props.actions.loadTimeCards();
    });
    this.props.actions.loadUsers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.timeCards) {
      if (this.props.timeCards !== nextProps.timeCards) {
        this.setState({
          timeCards: nextProps.timeCards.sort(function (a, b) {
            return b.payPeriodWeekId - a.payPeriodWeekId || a.userId - b.userId;
          }),
        });
      }
    }
  }

  createTimeCardForUser = (payPeriodWeekId, userId) => {
    /* check if card for week AND user exists
    if (this.props.timeCards.filter(c => c.payPeriodWeekId === payPeriodWeekId).length > 0) {
      toast.error("Time card for selected week exists.");
      return;
    }
    */
    let timeCard = {};
    timeCard.userId = parseInt(userId, 10);
    timeCard.payPeriodWeekId = parseInt(payPeriodWeekId, 10);
    this.props.actions
      .saveTimeCard(timeCard)
      .then(() => {
        toast.success('Timecard created.');
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  render() {
    const { timeCards, userOptions, weekOptions, users } = this.props;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Time Cards</h1>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button className="primary mb-2" onClick={this.toggleModal}>
                Add
              </Button>
            </Col>
          </Row>
          <Row>
            {timeCards.length > 0 ? (
              timeCards.map((card) => (
                <TimeCard
                  key={card.id}
                  card={card}
                  payWeek={this.props.weeks.filter(
                    (w) => w.id === card.payPeriodWeekId
                  )}
                  user={users.filter((u) => u.id === card.userId)[0]}
                />
              ))
            ) : (
              <Col md={12}>
                <h4 className="my-4 ">No entries found</h4>
              </Col>
            )}
          </Row>
          <AddTimeCardForUserModal
            show={this.state.showModal}
            payWeekOptions={weekOptions}
            createTimeCard={this.createTimeCardForUser}
            toggle={this.toggleModal}
            userOptions={userOptions}
          />
        </Container>
      </div>
    );
  }
}

TimeAdminPage.propTypes = {
  timeCards: PropTypes.array,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const userOptions = usersToSelectOptions(state.users);

  const thirtyDaysBack = moment().subtract(30, 'days');
  const thirtyDaysForward = moment().add(30, 'days');
  const filtered = state.payPeriodWeeks.filter(
    (w) => moment(w.startDate) > thirtyDaysBack
  );
  const doubleFiltered = filtered.filter(
    (w) => moment(w.endDate) < thirtyDaysForward
  );
  const weekOptions = payPeriodsToSelectOptions(doubleFiltered);

  return {
    timeCards: state.timeCards,
    weekOptions: weekOptions,
    userOptions: userOptions,
    users: state.users,
    weeks: state.payPeriodWeeks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...timeCardActions, ...payWeekActions, loadUsers },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TimeAdminPage)
);



// WEBPACK FOOTER //
// ./src/components/timecard/TimeAdminPage.js